import {useDocumentsWithStatuses, getNextPendingDocumentId} from './useDocumentStatuses';

/**
 * Hook to get the next pending document ID that requires action.
 * Uses the centralized getNextPendingDocumentId utility function.
 *
 * @param {string | null} currentDocumentId - Optional current document ID to find next after it
 * @returns {string | null} ID of next pending document, or null if none found
 */
export default function useNextPendingDocumentId(currentDocumentId = null) {
    const documents = useDocumentsWithStatuses();

    return getNextPendingDocumentId(documents, currentDocumentId);
}
